module.exports = __webpack_public_path__ + "static/media/ukLaiFang2.b823aa6b.jpg";